import { useMemo } from 'react';

import { useFetchValidations } from 'common/components/DynamicForm/hooks/fetch-validations';
import Input from 'common/components/Input/StatefulInput';
import { InputWithReplace } from 'common/components/Input/StatefulInput/InputVariants';
import { useLocalization } from 'common/providers/LocaleProvider';
import { FieldName } from '../enums/form';
import { formatGiftCardCodeValue, isValidGiftCardPin } from '../utils/validation';
import { fetchGiftCardRules } from './validation-rules';

interface UseFormGroups {
  isEpayGiftCard: boolean;
}

export const useFormGroups = ({ isEpayGiftCard }: UseFormGroups) => {
  const { t } = useLocalization();
  const validationsRules = useFetchValidations(fetchGiftCardRules);

  const validatePin = (pin: string | Record<string, string>) =>
    typeof pin === 'string' && isValidGiftCardPin(pin)
      ? true
      : t('h24_validation_error_form_pin_pattern');

  return useMemo(
    () => [
      {
        initialValue: '',
        name: FieldName.Code,
        Component: InputWithReplace,
        ComponentProps: {
          replace: formatGiftCardCodeValue,
        },
        label: t('h24_gift_card_code'),
        validation: {
          required: true,
          rules: validationsRules?.code,
        },
      },
      ...(isEpayGiftCard
        ? [
            {
              initialValue: '',
              Component: Input,
              name: FieldName.Pin,
              label: t('h24_gift_card_pin'),
              validation: {
                required: true,
                functions: {
                  validatePin,
                },
              },
            },
          ]
        : []),
    ],
    [validationsRules, isEpayGiftCard]
  );
};
